<template>
  <a :href="channelLink" target="_blank">
    <img :src="`img/${channel}.png`" class="sched-app-logo">
  </a>
</template>

<script>
export default {
  computed: {
    channel () {
      return this.$store.state.channel.value
    },

    channelLink () {
      switch (this.$store.state.channel.value) {
        case 'main':
          return 'https://3abn.org/'
        case 'proc':
          return '#'
        case 'dare':
          return 'https://d2dnetwork.tv/'
        case 'int':
          return '#'
        case 'canada':
          return 'https://3abn.ca/'
        case 'kids':
          return 'https://3abnkids.tv/'
        case 'lat':
          return 'https://3abnlatino.tv/'
        case 'praise':
          return 'https://3abnpraisehim.tv/'
        case 'radio':
          return 'https://3abn.org/3abn-radio-broadcast.html'
      }
    }
  }
}
</script>

<style scoped>
.sched-app-logo {
  height: 90px;
  padding: 20px 0;
}
</style>
